/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Waiting_List_ConfirmInputs */

const en_waiting_list_confirm = /** @type {(inputs: Waiting_List_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do you really want to add this application to the waiting list?`)
};

const de_waiting_list_confirm = /** @type {(inputs: Waiting_List_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bewerbung wirklich zur Warteliste hinzufügen?`)
};

/**
* | output |
* | --- |
* | "Do you really want to add this application to the waiting list?" |
*
* @param {Waiting_List_ConfirmInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const waiting_list_confirm = /** @type {((inputs?: Waiting_List_ConfirmInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Waiting_List_ConfirmInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_waiting_list_confirm(inputs)
	return en_waiting_list_confirm(inputs)
});